module.exports = __webpack_public_path__ + "img/puregym-logo.1b509c95.svg";